import * as React from 'react';
import { fileAvatar } from 'utils/utils.files';
import { JRCFileProps } from './types';

export const JRCFileApplication = ({ mimetype = 'application/pdf' }: JRCFileProps) => {
    const file = fileAvatar(mimetype);
    return <img src={file.path} />;
};
